export default "__VITE_ASSET__CMJusw1h__"